/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import type { RootState } from 'common/store/types';

const extractPreviewData = (formControl: any) => Object
  .entries(formControl || {})
  .map(([key, { formData }]: any) => ({
    code: key,
    status: true,
    title: formData?.title?.value || null,
    description: formData?.description?.value || null,
    heading: formData?.heading?.value || null,
    sub_heading: formData?.sub_heading?.value || null,
    button_text: formData?.button_text?.value,
    // "header_image": "public/Isio_Engage_Home.jpg",
    // "file": null,
    // "link_title": null,
    // "video_id": null,
    // "transcript": null,
    // "read_more_file": null,
    // "html_content": null,
  }), []);

const homepagePreviewSlice = createSlice({
  name: 'homepagePreview',
  initialState: {
    children: [],
  } as any,
  reducers: {
    setHomepagePreviewData: (
      state,
      { payload }: PayloadAction<any>,
    ) => {
      const newChildren = extractPreviewData(payload);
      state.children = newChildren;
    },
    clearHomepagePreviewData: (state) => {
      state = homepagePreviewSlice.getInitialState();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = homepagePreviewSlice.getInitialState();
    });
  },
});

export const {
  setHomepagePreviewData,
  clearHomepagePreviewData,
} = homepagePreviewSlice.actions;

export default homepagePreviewSlice.reducer;
export const selectCurrentClient = (state: RootState) => state.auth;
